import { render, staticRenderFns } from "./FormsWidgetItem.vue?vue&type=template&id=1ef48d7a"
import script from "./FormsWidgetItem.vue?vue&type=script&lang=js"
export * from "./FormsWidgetItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports